import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './css/public.less' // Importing global styles

createApp(App).use(router).mount('#app')
